<template>
  <v-container fluid>
    <v-toolbar
      flat
      class="toolbar--white get-height action-bar overflow--y"
      :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    >
      <Breadcrumb :routes="breadcrumbItems" />
      <v-spacer></v-spacer>
      <v-btn
        round
        depressed
        color="accent"
        @click="openDrawer"
      >
        {{ $t('Common.addEmployee') }}
      </v-btn>
    </v-toolbar>

    <div class="page-content">
      <header class="page-header">
        <h1 class="page-title">[PROFILE_NAME]</h1>
      </header>

      <div class="page-body px-3">
        <p class="text--semibold pb-1">{{ $t('Common.description') }}</p>
        <p class="page-desc">Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat at fugit consequatur deserunt necessitatibus ratione consequuntur similique impedit earum illo aperiam culpa expedita modi, quasi reiciendis sequi soluta dolore magnam!</p>

        <p class="text--semibold pb-1">{{ $t('Common.permissions') }}</p>

        <v-expansion-panel flat>
          <v-expansion-panel-content
            v-for="(item, i) in 5"
            :key="i"
          >
            <div slot="header">
              Item
              <v-icon v-if="i !== 1" class="v-icon--status v-icon--check">check</v-icon>
              <v-icon v-else class="v-icon--status v-icon--close">close</v-icon>
            </div>
            <v-card>
              <ul class="roles-list">
                <li
                  v-for="(item,i) in 5"
                  :key="i"
                >
                  <v-layout>
                    <v-flex xs6>Lorem ipsum dolor sit amet</v-flex>
                    <v-flex xs6 class="text-xs-right">
                      <span class="text--semibold">Ver, editar e excluir</span>
                    </v-flex>
                  </v-layout>
                </li>
              </ul>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </div>
    </div>

    <access-profiles-drawer
      :show="drawer"
      @closeDrawer="closeDrawer"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import Breadcrumb from 'components/Breadcrumb'
import AccessProfilesDrawer from 'components/accessProfiles/accessProfilesDrawer'

export default {
  name: 'AccessProfilesPage',
  components: {
    Breadcrumb,
    AccessProfilesDrawer
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: state => state.mainMenu.isOpen
    })
  },
  data () {
    return {
      namespace: 'Views.AccessProfilesPage',
      breadcrumbItems: [
        { name: '', title: 'Admin' },
        { name: 'AccessProfilesPage', title: this.$t('Views.AccessProfilesPage.title') },
        { name: 'AccessProfilesDetailsPage', title: '[PROFILE_NAME]' }
      ],
      drawer: false
    }
  },
  methods: {
    openDrawer () {
      this.drawer = true
    },

    closeDrawer () {
      this.drawer = false
    },

    addEmployeess () {
      console.log('open drawer add employees')
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header,
.page-body {
  max-width: 589px;
}

.roles-list {
  background-color: $gray-1;
  list-style-type: none;
  padding-left: 0;

  li {
    border-top: 1px solid $gray-4;
    padding: 16px 16px;
  }
}
</style>

<style lang="scss">
.v-expansion-panel {
  border: 1px solid $gray-4;
  box-shadow: none;
}

.v-expansion-panel__header {
  padding-left: 48px;
  position: relative;

  .v-expansion-panel__header__icon {
    left: 14px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .v-icon--status {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
  }

  .v-icon--check {
    color: $success;
  }

  .v-icon--close {
    color: $error;
  }
}

.theme--light.v-expansion-panel .v-expansion-panel__container {
  border-color: $gray-4;
}
</style>
